import React from 'react'
import './App.css'
import RootNav from 'utils/navigation'

const App = () => <RootNav />

export default App
